import { useMemo } from "react";
import { LegalRepresentation } from "../../../models/classes/ApplicationStep3.class";
import { SolicitorTypeEnum } from "../../../models/enum/solicitor-type.enum";
import PrivateSolicitorForm from "../../../components/HOC/private-solicitor-form/private-solicitor-form";
import { P2Accordion, P2TextDescription, P2TextLabel } from "react-bootstrap-common-script";
import { LoanTypeEnum } from "../../../models/enum/loan-type.enum";
import ClockPendingTask from "../../../assets/svg/clock-pending-task";
// import { InfoCard } from "../../../components/info";
// import { InfoCircle } from "../../../assets/svg";
import { Helpers } from "../../../utils/helper";
import { OwnerType, StageDMessageInfo } from "../../../models/classes/stage-d/Review-Application.class";
import he from "he";
interface HdbCannotActProps {
  solicitor_type?: SolicitorTypeEnum | string;
  ConveyancingSetFormValue?: Function;
  legalRepresentation: LegalRepresentation;
  ConveyancingErrors?: any;
  loan_type?: LoanTypeEnum;
  displayChildOnly?: boolean;
  solicitorMessageInfo: StageDMessageInfo | undefined;
}

function HdbCannotActForm({ displayChildOnly = false, ...props }: HdbCannotActProps) {
  const showSecondConveyancing = useMemo(() => {
    if (
      props.ConveyancingErrors?.private_solicitor?.email_of_solicitor.isValid &&
      props.ConveyancingErrors?.private_solicitor?.name_of_firm.isValid &&
      props.ConveyancingErrors?.private_solicitor?.uen.isValid &&
      !props.legalRepresentation.private_solicitor?.represented_same_solicitor
    ) {
      return true;
    }
    return false;
  }, [props.ConveyancingErrors]);

  if (!props.solicitor_type) {
    return <></>;
  }

  return (
    <div className="polymer-stage-d-container__section">
      <div className="polymer-stage-d-container__title">
        <P2TextDescription color="#000" title="Message" size="1.5rem" />
      </div>
      <div className="polymer-stage-d-container__subtitle">
        <P2TextLabel bold={700} marginBottom="16px" label={props.solicitorMessageInfo?.subject} />
        <div className="polymer-stage-d-container__subtitle__date">
          <ClockPendingTask />
          <p>Received on {Helpers.formatDate(props.solicitorMessageInfo?.received_date ?? "")}</p>
        </div>
      </div>
      <P2TextLabel marginBottom="33px" bold={400} label={he.decode(props.solicitorMessageInfo?.message ?? "")} />

      {props.solicitorMessageInfo?.solicitor_request_type === "MORTGAGE" ? (
        <>
          <P2TextLabel bold={700} fontSize="1.125rem" label={getTitle(props.solicitorMessageInfo?.owner_type, true)} />
          <div className="polymer-legal-representation-segment">
            <P2Accordion displayChildOnly={displayChildOnly} defaultOpen={true} title={<P2TextLabel bold="700" label={"Private Lawyer"} />}>
              <PrivateSolicitorForm
                display_form_only
                legal_representation={props.legalRepresentation}
                ConveyancingSetFormValue={props.ConveyancingSetFormValue}
                user_type={getUserType(props.solicitorMessageInfo?.owner_type)}
                errors={props.ConveyancingErrors?.private_solicitor}
                loan_type={props.loan_type}
                variant="mortgage"
              />
            </P2Accordion>
          </div>
        </>
      ) : null}

      {props.solicitorMessageInfo?.solicitor_request_type === "CONVEYANCING" ? (
        <>
          <P2TextLabel bold={700} fontSize="1.125rem" label={getTitle(props.solicitorMessageInfo?.owner_type, false)} />
          <div className="polymer-legal-representation-segment">
            <P2Accordion displayChildOnly={displayChildOnly} defaultOpen={true} title={<P2TextLabel bold="700" label={"Private Lawyer"} />}>
              <PrivateSolicitorForm
                display_form_only
                legal_representation={props.legalRepresentation}
                ConveyancingSetFormValue={props.ConveyancingSetFormValue}
                user_type={getUserType(props.solicitorMessageInfo?.owner_type)}
                errors={props.ConveyancingErrors?.conveyancing_private_solicitor}
                loan_type={props.loan_type}
                variant="conveyancing"
              />
            </P2Accordion>
          </div>
        </>
      ) : null}

      {props.solicitorMessageInfo?.solicitor_request_type === "BOTH" ? (
        <>
          <P2TextLabel bold={700} fontSize="1.125rem" label={getTitle(props.solicitorMessageInfo?.owner_type, true)} />
          <div className="polymer-legal-representation-segment">
            <P2Accordion displayChildOnly={displayChildOnly} defaultOpen={true} title={<P2TextLabel bold="700" label={"Private Lawyer"} />}>
              <PrivateSolicitorForm
                display_form_only
                legal_representation={props.legalRepresentation}
                ConveyancingSetFormValue={props.ConveyancingSetFormValue}
                user_type={getUserType(props.solicitorMessageInfo?.owner_type)}
                errors={props.ConveyancingErrors?.private_solicitor}
                loan_type={props.loan_type}
                variant="default"
              />
            </P2Accordion>
            {showSecondConveyancing && (
              <div className="mt-3">
                <P2TextLabel bold="500" hasTooltip required color={"#333"} label={getTitle(props.solicitorMessageInfo?.owner_type, false)} />
                <div className="mt-2">
                  <PrivateSolicitorForm
                    display_form_only
                    legal_representation={props.legalRepresentation}
                    ConveyancingSetFormValue={props.ConveyancingSetFormValue}
                    user_type={getUserType(props.solicitorMessageInfo?.owner_type)}
                    variant="conveyancing"
                    errors={props.ConveyancingErrors?.conveyancing_private_solicitor}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      ) : null}

      {/* <div style={{ marginTop: 32, marginBottom: 24 }}>
        <InfoCard
          style={{
            backgroundColor: "#FFF",
            padding: "16px 12px 16px 8px",
          }}
          icon={<InfoCircle />}
          description={`Please reply by ${Helpers.formatDate(props.solicitorMessageInfo?.due_date ?? "")} or the application will be cancelled.`}
        />
      </div> */}
    </div>
  );
}

function getUserType(owner_type?: OwnerType) {
  switch (owner_type) {
    case "PROPOSED_OWNER":
      return "proposed";
    // Other cases are "CURRENT_OWNER" and "OUTGOING_OWNER"
    case "CURRENT_OWNER":
      return "current";
    case "OUTGOING_OWNER":
      return "outgoing";
    default:
      return "current";
  }
}

function getTitle(owner_type: OwnerType | undefined, isMortgage: boolean) {
  if (owner_type === "CURRENT_OWNER" || owner_type === "OUTGOING_OWNER") {
    if (isMortgage) {
      return `Legal representation for ${getUserType(owner_type)} owners' discharge of current loan`;
    } else {
      return `Legal representation for ${getUserType(owner_type)} owners' conveyancing process`;
    }
  } else {
    if (isMortgage) {
      return "Legal representation for proposed owners’ new mortgage loan";
    } else {
      return "Legal representation for proposed owners' conveyancing process";
    }
  }
}

export default HdbCannotActForm;
